import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { setCustomerOverlayNav } from '../../../../store/actions';
import { BodyThree } from '../../../../styles/theme/default/typography';
import FullHeadMenuDropdown from './FullHeadMenuDropdown';

const Wrapper = styled.div`
  background: white;
  border-bottom: 1px solid #ececec;
  position: relative;
  z-index: 1002;

  .container {
    max-width: 1100px !important;
  }

  ul {
    padding: 12px 0 0 0;
    list-style: none;
    margin: 0;
    display: flex;
    justify-content: space-around;

    a {
      text-decoration: none;
    }
  }

  .hovered-design-services {
    opacity: 0.7;
  }

  .gift-svg-container {
    width: 67px;
    position: relative;

    img {
      position: absolute;
      left: 0;
      bottom: -24px;
    }
  }
`;

function NavBottom() {
  const location = useLocation();
  const [hoveredItem, setHoveredItem] = useState(null);
  const dispatch = useDispatch();

  const handleOverlay = bool => {
    dispatch(setCustomerOverlayNav(bool));
  };

  useEffect(() => {
    if (itemsWithDropDown) {
      handleOverlay(true);
    } else {
      handleOverlay(false);
    }
  }, [hoveredItem]);

  useEffect(() => setHoveredItem(null), [location.pathname]);

  const itemsWithDropDown = [
    'bedroom',
    'living',
    'dining',
    'decor',
    'outdoor',
    'inspiration',
    'collections',
    'collaborations',
    'new',
    'office',
    'houseTours',
    'swatches',
    'gifts',
    'window'
  ].includes(hoveredItem);

  const isSingleItems = ['collaborations', 'houseTours'].includes(hoveredItem);

  return (
    <Wrapper>
      <div className="container" onMouseLeave={() => setHoveredItem(null)}>
        <ul className="nav-items left-side-nav">
          <LI
            onMouseEnter={() => setHoveredItem('new')}
            className={hoveredItem === 'new' ? 'custom-underline-wavy' : ''}
          >
            <BodyThree className="nav-item nav-item-new" as="span">
              New
            </BodyThree>
          </LI>

          <LI
            onMouseEnter={() => setHoveredItem('bedroom')}
            className={hoveredItem === 'bedroom' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Bedroom
            </BodyThree>
          </LI>
          <LI
            onMouseEnter={() => setHoveredItem('living')}
            className={hoveredItem === 'living' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Living
            </BodyThree>
          </LI>
          <LI
            onMouseEnter={() => setHoveredItem('dining')}
            className={hoveredItem === 'dining' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Dining
            </BodyThree>
          </LI>
          <LI
            onMouseEnter={() => setHoveredItem('office')}
            className={hoveredItem === 'office' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Office
            </BodyThree>
          </LI>
          <LI
            onMouseEnter={() => setHoveredItem('decor')}
            className={hoveredItem === 'decor' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Decor
            </BodyThree>
          </LI>
          <LI
            onMouseEnter={() => setHoveredItem('outdoor')}
            className={hoveredItem === 'outdoor' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Outdoor
            </BodyThree>
          </LI>

          <LI
            onMouseEnter={() => setHoveredItem('window')}
            className={hoveredItem === 'window' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Window
            </BodyThree>
          </LI>

          <LI
            onMouseEnter={() => setHoveredItem('gifts')}
            className={hoveredItem === 'gifts' ? 'custom-underline-slim' : ''}
          >
            <BodyThree className="nav-item" as="span">
              Gifts
            </BodyThree>
          </LI>

          <LI
            onMouseEnter={() => setHoveredItem('inspiration')}
            className={
              hoveredItem === 'inspiration' ? 'custom-underline-slim' : ''
            }
          >
            <BodyThree className="nav-item" as="span">
              Inspiration
            </BodyThree>
          </LI>

          {/*<LI*/}
          {/*  onMouseEnter={() => setHoveredItem('collaborations')}*/}
          {/*  className={*/}
          {/*    hoveredItem === 'collaborations' ? 'custom-underline-slim' : ''*/}
          {/*  }*/}
          {/*>*/}
          {/*  <BodyThree className="nav-item" as="span">*/}
          {/*    Collaborations*/}
          {/*  </BodyThree>*/}
          {/*</LI>*/}

          <LI
            onMouseEnter={() => setHoveredItem('swatches')}
            className={
              hoveredItem === 'swatches' ? 'custom-underline-slim' : ''
            }
          >
            <BodyThree className="nav-item" as="span">
              Swatches
            </BodyThree>
          </LI>

          <LI
            onMouseEnter={() => setHoveredItem('design-services')}
            className={
              hoveredItem === 'design-services' ? 'custom-underline-slim' : ''
            }
          >
            <BodyThree className="nav-item" as="span">
              <Link className="design-services-item" to="/design-services">
                Design Services
              </Link>
            </BodyThree>
          </LI>
        </ul>
        <FullHeadMenuDropdown
          itemsWithDropDown={itemsWithDropDown}
          hoveredItem={hoveredItem} //hoveredItem
          isSingleItems={isSingleItems}
        />
      </div>
    </Wrapper>
  );
}

export default NavBottom;

const LI = styled.li`
  cursor: pointer;
  padding-bottom: 12px;
  /* border-bottom: 2px solid white; */
  /* transition: 0.4s all; */
  /* flex: 1 1 0px; */
  display: flex;
  justify-content: center;

  .nav-item-new {
    color: #a83569;
  }

  .design-services-item {
    color: ${({ theme }) => theme.colors.charcoal};
  }

  .nav-item {
    /* transition: 0.4s all; */
    /* &:hover {
      color: ${({ theme }) => theme.colors.french};
    } */
  }

  &:hover {
    /* border-bottom: 2px solid #2a5caf; */
  }
`;
